import React, { useMemo } from 'react';
import { truncateString } from '../utils/stringManipulation';

type Props<T extends React.ElementType> = {
  as?: T;
  text: string;
  limit: number;
  tooltip?: string;
} & React.ComponentPropsWithoutRef<T>;

export function TruncatedText<T extends React.ElementType = 'span'>({
  as,
  text,
  limit,
  tooltip,
  ...rest
}: Props<T>) {
  const Component = as || 'span';

  const truncated = useMemo(() => truncateString(text, limit), [text, limit]);
  const isTruncated = truncated !== text;

  let dataTitle;

  if (tooltip !== undefined) {
    dataTitle = tooltip;
  } else if (isTruncated) {
    dataTitle = text;
  }

  return (
    <Component {...rest} data-title={dataTitle}>
      {truncated}
    </Component>
  );
}
